import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth.store';
import { NickyButtonComponent } from 'src/app/components/form/nicky-button/nicky-button.component';
import { isPublicProfileRoute } from 'src/app/utils/public-profile.utils';

@Component({
  selector: 'app-back-button',
  imports: [CommonModule, TranslateModule, NickyButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (shouldShowBackButton()) {
      <div class="m-2 z-50">
        <app-nicky-button iconLeft="ph ph-arrow-left" variant="text" size="small" (click)="handleBackNavigation()">
          {{ 'back' | translate }}
        </app-nicky-button>
      </div>
    }
  `,
})
export class BackButtonComponent {
  protected router = inject(Router);
  protected authStore = inject(AuthStore);

  shouldShowBackButton = computed(() => {
    return this.authStore.authenticated() && isPublicProfileRoute(this.router.url);
  });

  handleBackNavigation(): void {
    if (document.referrer && document.referrer.includes(window.location.hostname)) {
      window.history.back();
    } else {
      this.router.navigate(['/overview']);
    }
  }
}
